import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DevErrorBoundary } from "./components/DevErrorBoundary";
import { installDevErrorReporter } from "./lib/dev-error-reporter";
import "./index.css";

installDevErrorReporter();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <DevErrorBoundary>
      <App />
    </DevErrorBoundary>
  </React.StrictMode>,
);
